export default __webpack_public_path__ + "static/media/s.f38efa48.svg";